import { DefaultState } from 'store/types';
import { ReservationProviderStatuses, OptionRequiredOptionalNotSupportedStatuses } from 'store/reducers/reservation-provider/types';

export const GET_RESERVATION_PROVIDER_SETTINGS_REQUEST = 'GET_RESERVATION_PROVIDER_SETTINGS_REQUEST';
export const GET_RESERVATION_PROVIDER_SETTINGS_SUCCESS = 'GET_RESERVATION_PROVIDER_SETTINGS_SUCCESS';
export const GET_RESERVATION_PROVIDER_SETTINGS_FAILURE = 'GET_RESERVATION_PROVIDER_SETTINGS_FAILURE';
export const GET_RESERVATION_PROVIDER_SETTINGS_CLEAR = 'GET_RESERVATION_PROVIDER_SETTINGS_CLEAR';

export interface ReservationProviderSettingsParams {
  includeLodgingPolicy: boolean;
}

export interface ReservationProviderSettings {
  id?: string;
  name: string;
  email?: string;
  phoneNumber?: string;
  website?: string;
  status: ReservationProviderStatuses;
  requestNumberRequired?: OptionRequiredOptionalNotSupportedStatuses;
  lodgingPolicyId?: string;
  sendNotification?: boolean;
  notificationEmail?: string;
  labelColor: string;
  lodgingPolicy: string;
}

export type GetReservationProviderSettingsState = DefaultState & {
  contents?: ReservationProviderSettings;
};

interface GetReservationProviderSettingsRequest {
  type: typeof GET_RESERVATION_PROVIDER_SETTINGS_REQUEST;
}

interface GetReservationProviderSettingsSuccess {
  type: typeof GET_RESERVATION_PROVIDER_SETTINGS_SUCCESS;
  contents: ReservationProviderSettings;
}

interface GetReservationProviderSettingsFailure {
  type: typeof GET_RESERVATION_PROVIDER_SETTINGS_FAILURE;
}

interface GetReservationProviderSettingsClear {
  type: typeof GET_RESERVATION_PROVIDER_SETTINGS_CLEAR;
}

export type GetReservationProviderSettingsActionTypes = GetReservationProviderSettingsRequest | GetReservationProviderSettingsSuccess | GetReservationProviderSettingsFailure | GetReservationProviderSettingsClear;